import EF from 'ef/ef';
import Backbone from 'backbone';
import Chaplin from 'chaplin';
import $ from 'jquery';

const Attempt = Chaplin.Model.extend({
  initialize: function (attempt, options) {
    Chaplin.Model.prototype.initialize.apply(this, arguments);
    this.assessment = options.assessment;
  },

  answerQuestion: function (question_id, answer_id) {
    this.set('current_question_id', question_id.toString());
    // add an object to track attempted question + answer apart from just set(question_id, answer_id)
    // but keep backward compatibility
    const ansId = answer_id.toString();
    this.set(question_id, ansId);
    const attempted = this.has('attempted') ? this.get('attempted') : {};
    attempted[question_id] = ansId;
    this.set('attempted', attempted);

    const answer = { question_id, answer_id };
    const answers = this.get('answers');
    if (answers) {
      const currentAnswer = answers.find(answer => String(answer.question_id) === String(question_id));
      if (currentAnswer) {
        currentAnswer.answer_id = answer_id;
      } else {
        answers.push(answer);
        this.set('answers', answers);
      }
    } else {
      this.set('answers', [answer]);
    }
  },
  url: function () {
    return this.assessment.url(this.isSaving);
  },
  parse: function (response) {
    return EF.ContentProvider.AssessmentService.parseAttempt(response);
  },
  toJSON: function () {
    return EF.ContentProvider.AssessmentService.getAttemptJSON(this);
  },

  isComplete: function () {
    return EF.ContentProvider.AssessmentService.isAttemptComplete(this);
  },

  isSubSetComplete: function () {
    const questions = this.assessment.get('questions');
    return questions.every(q => {
      return !!this.get(q.get('id'));
    });
  },

  getQuestionResults: function () {
    return this.assessment.get('questions').countBy(question => {
      return question.isSuccessAttempt(this.get(question.id)) ? 'correct' : 'incorrect';
    });
  },

  score: function () {
    if (!this.assessment.get('local')) {
      throw new Error('not able to score assessments stored in homeroom');
    }
    const results = this.getQuestionResults();

    results.correct = results.correct || 0;
    results.incorrect = results.incorrect || 0;
    results.incorrect_questions = this.assessment.get('questions').reduce((qs, question) => {
      if (!question.isSuccessAttempt(this.get(question.id))) {
        qs.push(question.get('text'));
      }
      return qs;
    }, []);
    results.incorrect_feedback = results.incorrect_questions.map(q => `Incorrect Feedback For: ${q}`);

    results.total = this.assessment.get('questions').length;
    results.grade = (results.correct / results.total) * 100;

    if (this.assessment.get('passing_grade')) {
      results.state = results.grade >= this.assessment.get('passing_grade') ? 'passed' : 'failed';
    } else {
      results.state = 'passed';
    }

    return results;
  },

  isFinished: function () {
    return EF.ContentProvider.AssessmentService.isAttemptFinished(this);
  },
  save: function (force) {
    this.isSaving = true;
    const self = this;

    const assessmentSaved = data => {
      this.isSaving = false;
      if (data.state === 'started') {
        EF.trigger('assessment:incomplete');
      } else {
        EF.trigger('assessment:complete', data);
        if (data.state === 'passed') {
          EF.trigger('assessment:passed', data.grade);
        } else if (data.state === 'failed') {
          EF.trigger('assessment:failed', data.grade);
        }
      }
      const parseData = EF.ContentProvider.AssessmentService.parseAttempt(data);
      self.trigger('assessment:saved', parseData);
      self.unset('force_grading', { silent: true });
    };

    if (this.assessment.get('local')) {
      const d = $.Deferred();
      const result = this.score();
      EF.module.progress.saveLocalActivityProgress({
        attempt: 1,
        enrollment_id: EF.enrollment.get('id'),
        grade: result.grade,
        passed: result.state === 'passed',
        slug: this.assessment.get('slug'),
        module_key: EF.module.get('key'),
      });
      d.done(assessmentSaved);
      d.resolve(result);
    } else {
      if (force && force === true) {
        this.set('force_grading', true, { silent: true });
      }

      const jqXHR = Backbone.Model.prototype.save.apply(this, [
        null,
        {
          headers: { Authorization: `Bearer ${this.get('token')}` },
          parse: true,
          patch: true,
        },
      ]);
      jqXHR.done(assessmentSaved).fail(function () {
        this.isSaving = false;
        self.trigger('assessment:save:failure');
        EF.trigger('assessment:save:failure');
      });
    }
  },
});

export default Attempt;
